<template>
  <div class="overview-card" @click="toJump">
    <div class="name">{{ name }}</div>
    <div class="value">
      {{ value }}<span v-if="company">{{ company }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "overview-card",
  props: {
    name: String,
    value: [String, Number],
    path: String,
    company: String
  },
  setup(props) {
    const toJump = () => {
      if (props.path) {
        window.open(props.path, "_blank");
      }
    };
    return {
      toJump
    };
  }
};
</script>
<style scoped lang="less">
.overview-card {
  position: relative;
  top: 0;
  height: 100%;
  padding: 16px;
  background-color: #f7f8fa;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  .name {
    color: #4e5969;
    font-weight: 400;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 22px;
  }
  .value {
    margin-top: 8px;
    color: #1d2129;
    font-size: 24px;
    font-family: DINBold;
    line-height: 24px;
    span {
      position: relative;
      top: -2px;
      margin-left: 6px;
      color: #86909c;
      font-weight: 400;
      font-size: 12px;
    }
  }
}
.overview-card:hover {
  top: -4px;
  background-color: #e5e6eb;
}
</style>
